import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { createSelector, createStructuredSelector } from 'reselect';
import { isCartBoxBuilderPopupShownSelector, isBoxBuilderSelectProductsDrawerShownSelector, isSuperSpeedBoxConfirmationPopupShownSelector, isSuperSpeedBoxTypeChangeConfirmationPopupShownSelector } from 'swag-client-common/redux/popup-manager/popup-manager.selector';
import { hidePopup, showPopup } from 'swag-client-common/redux/popup-manager/popup-manager.actions';
import { BOX_BUILDER_SELECT_PRODUCTS_DRAWER, CART_BOX_BUILDER_POPUP } from 'swag-client-common/constants';
import { currentStepSelector, editingBoxTypeBoxIdSelector, hasUnsavedChangesSelector } from '../../../redux/box-builder/box-builder.selectors';
import { saveEditedBoxItselfInfo, saveSelectedCartItemsToBox, setEditingBoxTypeBoxId } from '../../../redux/box-builder/box-builder.actions';
import { STEPS } from '../../../redux/box-builder/box-builder.constants';
import { SuperSpeedBoxConfirmationPopupComponent } from './super-speed-box-confirmation-popup';
const TITLE = 'Keep in mind!';
const CONFIRM_BTN_TEXT = 'Keep Box Super Speed';
const CONTINUE_BTN_TEXT = 'Continue';
const MSG = `
  You are adding a non super speed product to your box.
  Adding this product will make this box non super speed. 
  Do you want to continue?
`;
const shouldPreventOnLocationChangeSelector = createSelector(hasUnsavedChangesSelector, isCartBoxBuilderPopupShownSelector, isSuperSpeedBoxConfirmationPopupShownSelector, isBoxBuilderSelectProductsDrawerShownSelector, (hasUnsavedChanges, isBoxBuilderPopupShown, isSuperSpeedBoxConfirmationPopup, isBoxBuilderSelectProductsDrawerShown) => {
  return hasUnsavedChanges && (isBoxBuilderPopupShown || isSuperSpeedBoxConfirmationPopup || isBoxBuilderSelectProductsDrawerShown);
});
const onCancelPopupShownSelector = createSelector(currentStepSelector, currentStep => [STEPS.SELECT_ADDONS_FOR_BOX, STEPS.SELECT_PRODUCTS_FOR_BOX].includes(currentStep) ? BOX_BUILDER_SELECT_PRODUCTS_DRAWER : CART_BOX_BUILDER_POPUP);
const mapStateToProps = createStructuredSelector({
  id: editingBoxTypeBoxIdSelector,
  open: isSuperSpeedBoxConfirmationPopupShownSelector,
  onCancelPopupShown: onCancelPopupShownSelector,
  shouldPreventOnLocationChange: shouldPreventOnLocationChangeSelector,
  continueText: () => CONTINUE_BTN_TEXT,
  confirmText: () => CONFIRM_BTN_TEXT,
  title: () => TITLE,
  msg: () => MSG
});
const mapDispatchToProps = dispatch => ({
  handleKeepSuperSpeed: (onCancelPopupShown, id) => {
    dispatch(hidePopup({
      shouldControlScroll: false
    }));
    setTimeout(() => {
      if (id) {
        dispatch(setEditingBoxTypeBoxId(id));
      }
      dispatch(showPopup({
        popup: onCancelPopupShown
      }));
    }, 250);
  },
  handleContinue: (onCancelPopupShown, id) => {
    dispatch(hidePopup({
      shouldControlScroll: false
    }));
    setTimeout(() => {
      if (id) {
        dispatch(setEditingBoxTypeBoxId(id));
      }
      dispatch(saveSelectedCartItemsToBox());
      dispatch(showPopup({
        popup: onCancelPopupShown
      }));
    }, 250);
  }
});
export const SuperSpeedBoxConfirmationPopup = withRouter(connect(mapStateToProps, mapDispatchToProps)(SuperSpeedBoxConfirmationPopupComponent));

//------type change popup logic ------------

const CONTINUE_BTN_TEXT_BOX_TYPE_CHANGE = 'Update Box Type';
const MSG_BOX_TYPE_CHANGE = `
  You are changing a super speed box type to a non super speed.
  Do you want to continue?
`;
const mapStateToPropsBoxTypeChange = createStructuredSelector({
  id: editingBoxTypeBoxIdSelector,
  open: isSuperSpeedBoxTypeChangeConfirmationPopupShownSelector,
  onCancelPopupShown: onCancelPopupShownSelector,
  shouldPreventOnLocationChange: shouldPreventOnLocationChangeSelector,
  continueText: () => CONTINUE_BTN_TEXT_BOX_TYPE_CHANGE,
  confirmText: () => CONFIRM_BTN_TEXT,
  title: () => TITLE,
  msg: () => MSG_BOX_TYPE_CHANGE
});
const mapDispatchToPropsBoxTypeChange = dispatch => ({
  handleKeepSuperSpeed: (onCancelPopupShown, id) => {
    dispatch(hidePopup({
      shouldControlScroll: false
    }));
    setTimeout(() => {
      if (id) {
        dispatch(setEditingBoxTypeBoxId(id));
      }
      dispatch(showPopup({
        popup: onCancelPopupShown
      }));
    }, 250);
  },
  handleContinue: (_, id) => {
    dispatch(hidePopup({
      shouldControlScroll: false
    }));
    setTimeout(() => {
      if (id) {
        dispatch(saveEditedBoxItselfInfo());
      }
    }, 250);
  }
});
export const SuperSpeedBoxTypeChangeConfirmationPopup = withRouter(connect(mapStateToPropsBoxTypeChange, mapDispatchToPropsBoxTypeChange)(SuperSpeedBoxConfirmationPopupComponent));